// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__VFP86","loader_text":"style_loader_text__4rykr","spin":"style_spin__giGLE","spinner":"style_spinner__AO3V+"};